module.exports = __webpack_public_path__ + "media/images/keeplist_ic-fill-6abce3e2012d98ab79888a770214b5ed.svg";